<script>
export default {
    props: {
        label: {
            type: String,
            default: null
        },

        description: {
            type: String,
            default: null
        },

        required: {
            type: Boolean,
            default: false
        },

        validationState: {
            type: String,
            default: null
        },

        errorMessage: {
            type: String,
            default: null
        },

        hint: {
            type: String,
            default: null
        },

        hasError: {
            type: Boolean,
            default: false
        },

        warningMessage: {
            type: String,
            default: null
        }
    },

    computed: {
        classObject() {
            return {
                'form-group': true,
                'has-success': this.validationState === 'success',
                'has-warning': this.validationState === 'warning',
                'has-error': this.validationState === 'error',
                'has-error': this.hasError === true
            }
        },

        subTextClassObject() {
            return {
                'help-block': true,
                'text-red': this.showErrorSubtext,
                'text-warning': this.showWarningSubtext
            };
        },

        subText() {
            if (this.showErrorSubtext) {
                return this.errorMessage;
            } else if(this.showWarningSubtext) {
                return this.warningMessage;
            } else if (this.hint !== null) {
                return this.hint;
            } else {
                return null;
            }
        },

        showErrorSubtext() {
            return (this.validationState === 'error' && this.errorMessage !== null)
                   || (this.hasError && this.errorMessage !== null);
        },

        showWarningSubtext() {
            return this.validationState === 'warning' && this.warningMessage !== null;
        }
    }
}
</script>

<template>
    <div :class="classObject">
        <label class="control-label" v-if="label">
            <slot name="label">
                <span>{{label}}</span>
                <span v-if="required" class="text-danger">*</span>
            </slot>

            <template v-if="description">
                <br><small>{{description}}</small>
            </template>
        </label>

        <slot></slot>

        <template v-if="subText">
            <small :class="subTextClassObject">{{subText}}</small>
        </template>
    </div>
</template>